import React from "react";
import { Progress } from "semantic-ui-react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { stateProps } from "../../types";
import NumberIcon from "../styledComponents/numberIcon.component";

const Header: React.FC = () => {
  const step = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo.step
  );

  var currentStep = 0;
  if (step < 15 && step >= 1) {
    currentStep = step * 2.5;
  } else if (step >= 15 && step < 19) {
    currentStep = (step - 14) * 8 + 35; // 35 is breakpoint
  } else if (step >= 19 && step < 26) {
    currentStep = (step - 18) * 4 + 67; // 67 is breakpoint
  } else if (step === 26) {
    currentStep = 100;
  }

  return (
    <Box
      sx={{
        pl: { xs: "0px", sm: "50px", md: "100px" },
        pt: "35px",
        pr: { xs: "0px", sm: "50px", md: "100px" },
        width: { xs: "100%", sm: "100%", md: "100%" },
        height: { xs: "100%", sm: "100%", md: "100%" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            paddingBottom: "10px",
            width: "34%",
          }}
        >
          <NumberIcon breakPoint={0} currentStep={currentStep} numberValue={1} />
          <Typography
            style={currentStep > 0 ? { color: "#333333" } : { color: "#70707080" }}
            sx={{
              letterSpacing: "0.26px",
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "13px", xl: "18px" },
              lineHeight: { xs: "9px", sm: "9px", md: "9px", xl: "12px" },
              color: "#333333",
              opacity: 1,
              alignItems: "center",
            }}
          >
            Personal Details
          </Typography>
        </Box>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            paddingBottom: "10px",
            width: "33%",
          }}
        >
          <NumberIcon breakPoint={35} currentStep={currentStep} numberValue={2} />
          <Typography
            style={currentStep > 0 ? { color: "#333333" } : { color: "#70707080" }}
            sx={{
              letterSpacing: "0.26px",
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "13px", xl: "18px" },
              lineHeight: { xs: "9px", sm: "9px", md: "9px", xl: "12px" },
              color: "#333333",
              opacity: 1,
              alignItems: "center",
            }}
          >
            Bank Account Details
          </Typography>
        </Box>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            paddingBottom: "10px",
            width: "33%",
          }}
        >
          <NumberIcon breakPoint={67} currentStep={currentStep} numberValue={3} />
          <Typography
            style={currentStep > 0 ? { color: "#333333" } : { color: "#70707080" }}
            sx={{
              letterSpacing: "0.26px",
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "13px", xl: "18px" },
              lineHeight: { xs: "9px", sm: "9px", md: "9px", xl: "12px" },
              color: "#333333",
              opacity: 1,
              alignItems: "center",
            }}
          >
            Documents
          </Typography>
        </Box>
      </Box>
      <Box>
        <Progress percent={currentStep} color={"blue"} size={"tiny"} />
      </Box>
    </Box>
  );
};

export default Header;
